import React, { Component } from "react";
import { connect } from "react-redux";
import { Header } from "semantic-ui-react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import languages from "../languages.json";

export default connect(mapStateToProps)(
    class StackedBarChart extends Component {
        render() {
            let t = languages[this.props.language];

            let data = [
                {
                    name: t.chart.after,
                    [t.financial_rent.title]: this.props.tco.financial_rent,
                    [t.vehicle_tco.title]: this.props.tco.vehicle_tco,
                    [t.company_tco.title]: this.props.tco.company_tco,
                },
                {
                    name: t.chart.before,
                    [t.financial_rent.title]: this.props.initial_tco.initial_financial_rent,
                    [t.vehicle_tco.title]: this.props.initial_tco.initial_vehicle_tco,
                    [t.company_tco.title]: this.props.initial_tco.initial_company_tco,
                },
            ];

            let max_axis =
                Math.ceil(
                    (1.5 *
                        (this.props.tco.company_tco +
                            this.props.tco.financial_rent +
                            this.props.tco.vehicle_tco)) /
                        1000
                ) * 1000;

            return (
                <div>
                    <Header as="h2" textAlign="center" style={{ margin: 0 }}>TCO</Header>
                    <ResponsiveContainer width="100%" height={500}>
                        <BarChart
                            width={100}
                            height={100}
                            data={data}
                            margin={{ top: 10, right: 30, left: 20, bottom: 5 }}>
                            <XAxis
                                dataKey="name"
                                tick={{
                                    fill: "black"
                                }}
                                tickLine={false}
                            />
                            <YAxis
                                unit=" €"
                                tick={{
                                    fill: "black"
                                }}
                                tickFormatter={(tick) => tick.toLocaleString(this.props.language)}
                                domain={[0, max_axis]}
                                type="number"
                            />
                            <CartesianGrid strokeDasharray="3 3" />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey={t.financial_rent.title} stackId="a" fill="#90c2e7" />
                            <Bar dataKey={t.vehicle_tco.title} stackId="a" fill="#f8b88d" />
                            <Bar dataKey={t.company_tco.title} stackId="a" fill="#c6f2d5" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            );
        }
    }
);

function mapStateToProps(state) {
    return {
        data: state.reducerData,
        tco: state.reducerTco,
        initial_tco: state.reducerInitialTco,
        language: state.reducerLanguage,
    };
}



// WEBPACK FOOTER //
// ./src/components/chart.js